module.exports = __webpack_public_path__ + "img/step2.66be6c12.png";